import React, {FC, ReactNode, useEffect, useMemo} from 'react'

import {useABTestConfig} from '@/components/context/ABTest'
import {analytics} from '@/utils/tracking/analytics'

const filterVariants = (variants: ReactNode): Record<string, ReactNode> => {
  const possibleVariants: Record<string, ReactNode> = {}

  React.Children.forEach(variants, (element) => {
    if (React.isValidElement(element)) {
      possibleVariants[element.props.name as string] = element
    }
  })

  return possibleVariants
}

type ExperimentProps = {
  name: string
}

export const Experiment: FC<React.PropsWithChildren<ExperimentProps>> = ({name, children}) => {
  const abTestConfig = useABTestConfig().config
  const variants = useMemo(() => filterVariants(children), [children])
  const variantKeyIndex = abTestConfig[name]
  const variantKey = Object.keys(variants).sort()[variantKeyIndex]

  useEffect(() => {
    // No page has an assignment until the browser resolves one; registering before then would
    // report `undefined` as the visitor's variant.
    if (variantKey === undefined) {
      return
    }

    analytics.register({[name]: variantKey})
  }, [name, variantKey])

  return <>{variants[variantKey]}</>
}
